const programRegistrationFields = state => state.programRegistrationFields;
const registrationFieldsLoaded = state => state.registrationFieldsLoaded;
const createTeamAfterSignIn = state => state.createTeamAfterSignIn;
const createTeamFormData = state => state.createTeamFormData;

export default {
  programRegistrationFields,
  registrationFieldsLoaded,
  createTeamAfterSignIn,
  createTeamFormData
};
